import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderConfirmation = () => {
  const location = useLocation();
  const orderNumber = location?.state?.orderNumber;

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center">
      <div className="mb-6">
        <CheckCircle size={64} className="mx-auto text-green-600" />
      </div>
      <h1 className="text-3xl font-medium tracking-wide mb-4">ORDER CONFIRMED</h1>
      {orderNumber ? (
        <div className="mb-4 text-sm text-gray-800">
          Order ID: <span className="font-medium">{orderNumber}</span>
        </div>
      ) : null}
      <p className="text-gray-600 mb-8">
        Thank you for your order! You will receive a confirmation email shortly with your order details and tracking information.
      </p>
      <div className="space-y-4">
        <Link
          to="/shop/new-arrivals"
          className="inline-block w-full bg-black text-white py-3 px-6 text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors"
        >
          CONTINUE SHOPPING
        </Link>
        <Link
          to="/orders"
          className="inline-block w-full border border-gray-300 py-3 px-6 text-sm font-medium tracking-wide hover:bg-gray-50 transition-colors"
        >
          VIEW MY ORDERS
        </Link>
        <Link
          to="/home"
          className="inline-block w-full border border-black py-3 px-6 text-sm font-medium tracking-wide hover:bg-black hover:text-white transition-colors"
        >
          RETURN TO HOME
        </Link>
      </div>
    </div>
  );
};

export default OrderConfirmation;